module.exports = __webpack_public_path__ + "img/v_spades.1afb99c9.png";